import React, { useId } from "react";

import Select, { components } from "react-select";

import type { IDropdownProps, IOption } from "./interfaces";

import { Label } from "../Field";
import {
  ClearIndicator,
  DropdownIndicator,
  MultiValueRemove,
  Option,
} from "./components";
import { useSelectStyles } from "./hooks/useSelectStyles";

export const Dropdown: React.FC<IDropdownProps> = ({
  options,
  onChange,
  value,
  label,
  isInvalid = false,
  noOptionsMessage,
  defaultValue,
  isMulti = false,
  placeholder = "Please select",
  isClearable = true,
  defaultMenuIsOpen = false,
  isSearchable = true,
  customStyles = {},
  closeMenuOnSelect = true,
  isDisabled = false,
  ariaErrorMessageId,
}) => {
  const colourStyles = useSelectStyles(isMulti, isInvalid);
  const instanceId = useId();

  return (
    <div className="flex flex-col gap-2">
      {label && <Label isInvalid={!!isInvalid}>{label}</Label>}
      <Select
        instanceId={instanceId}
        aria-invalid={isInvalid || undefined}
        aria-errormessage={ariaErrorMessageId}
        getOptionLabel={(option) => option.label}
        defaultMenuIsOpen={defaultMenuIsOpen}
        closeMenuOnSelect={closeMenuOnSelect}
        isMulti={isMulti}
        isDisabled={isDisabled}
        placeholder={placeholder}
        value={value}
        defaultValue={defaultValue}
        hideSelectedOptions={false}
        isSearchable={isSearchable}
        onChange={onChange}
        options={options}
        isClearable={isClearable}
        styles={{ ...colourStyles, ...customStyles }}
        menuPlacement="auto"
        menuPortalTarget={
          typeof document !== "undefined" ? document.body : null
        }
        noOptionsMessage={noOptionsMessage}
        components={{
          IndicatorSeparator: () => null,
          Option,
          MultiValueRemove,
          ClearIndicator,
          DropdownIndicator,
          SingleValue: ({ children, ...props }) => {
            const singleValue: IOption | null = !isMulti
              ? (value as IOption)
              : null;

            return (
              <components.SingleValue className="flex" {...props}>
                {singleValue && singleValue.icon && (
                  <div className="me-2 flex justify-center items-center">
                    {singleValue.icon}
                  </div>
                )}
                {children}
              </components.SingleValue>
            );
          },
          Input: (inputProps) => {
            return <components.Input {...inputProps} />;
          },
        }}
        classNamePrefix={isInvalid ? "react-select-invalid" : "react-select"}
      />
    </div>
  );
};
